import { gsap, ScrollToPlugin } from "gsap/all";

export default () => {
  gsap.registerPlugin(ScrollToPlugin);

  //------------------------------------------------------//
  // 📝 Form labels
  //------------------------------------------------------//
  function getFieldLabel(input) {
    const field = input.closest(".gfield");
    if (!field) return null;
    return field.querySelector(".gfield_label");
  }

  document
    .querySelectorAll(".gfield input, .gfield textarea")
    .forEach(function (input) {
      if (!input.closest(".gfield")) return;

      // Check if value
      if (input.value) {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL"
        ) {
          input.previousElementSibling.classList.add("selectedInput");
        }
        const label = getFieldLabel(input);
        if (label) label.classList.add("selectedInput");
      }
      // On focus
      input.addEventListener("focus", () => {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL" &&
          !input.value
        ) {
          input.previousElementSibling.classList.add("selectedInput");
        }
        const label = getFieldLabel(input);
        if (label) label.classList.add("selectedInput");
      });
      // On focus loss
      input.addEventListener("blur", () => {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL" &&
          !input.value
        ) {
          input.previousElementSibling.classList.remove("selectedInput");
        }
        if (!input.value) {
          const label = getFieldLabel(input);
          if (label) label.classList.remove("selectedInput");
        }
      });
    });
  // END 📝 Form labels -------------------------------------//

  //--------------------------------//
  // Validation 
  //--------------------------------//
  document.querySelectorAll('[aria-required="true"]').forEach(input => {
    const checkState = () => {
      const hasValue = input.value.trim().length > 0;
      input.classList.toggle('is-filled', hasValue);
      input.classList.toggle('is-empty', !hasValue);
    };

    // mark that user interacted, so you don’t show red borders from the start
    input.addEventListener('blur', () => {
      input.classList.add('user-interacted');
      checkState();
    });

    input.addEventListener('input', checkState);
    checkState(); // run once on load
  });

  // END Validation --------------//

  //--------------------------------//
  // scroll to form 
  //--------------------------------//
  const errorMessage = document.querySelector('.gform_submission_error');
  if (errorMessage) {
    gsap.to(window, { duration: 0.5, delay: 0.5, scrollTo: { y: errorMessage, offsetY: 100 } });
  }
  // END scroll to form --------------//

  //--------------------------------//
  // Set to local storage 
  //--------------------------------//
  (function () {
    const storageKey = 'alloy_localstorage';

    function getData() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '{ }');
      } catch {
        return {};
      }
    }

    function saveData(data) {
      localStorage.setItem(storageKey, JSON.stringify(data));
    }

    function updateLabelClass(field, input) {
      const label = field.querySelector('.gfield_label');
      if (!label) return;

      label.classList.toggle('selectedInput', !!input.value);
    }

    function initLocalStorageFields() {
      document.querySelectorAll('.gfield').forEach(field => {
        const cls = [...field.classList].find(c => c.startsWith('alloy-localstorage-'));
        if (!cls) return;

        const key = cls.replace('alloy-localstorage-', '');
        const input = field.querySelector('input, select, textarea');
        if (!input) return;

        const data = getData();

        if (key in data && !input.value) {
          input.value = data[key];
        }

        updateLabelClass(field, input);

        if (input.dataset.alloyLocalstorageBound) return;
        input.dataset.alloyLocalstorageBound = '1';

        input.addEventListener('input', () => {
          const data = getData();
          data[key] = input.value;
          saveData(data);
          updateLabelClass(field, input);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initLocalStorageFields);

    if (window.jQuery) {
      jQuery(document).on('gform_post_render', initLocalStorageFields);
    }
  })();
  // END Set to local storage --------------//


};
